import { render, staticRenderFns } from "./CoordinatesPointer.vue?vue&type=template&id=4d535eb9&scoped=true&lang=pug"
import script from "./CoordinatesPointer.vue?vue&type=script&lang=js"
export * from "./CoordinatesPointer.vue?vue&type=script&lang=js"
import style0 from "./CoordinatesPointer.vue?vue&type=style&index=0&id=4d535eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d535eb9",
  null
  
)

export default component.exports